import { format, parseISO } from 'date-fns';
import { ConsumptionFilter } from '../../stores/consumption.store';
import { de } from 'date-fns/locale';
import { LoadCurveSummaryEntry } from '../../../../core/clients/omni-core/models';

export interface ConsumptionData {
  xAxisData: string[];
  yAxisData: number[];
}

export interface ConsumptionGraphConfigOptions {
  view: ConsumptionFilter['view'];
  utilityType: ConsumptionFilter['data']['utilityType'];
  granularity: ConsumptionFilter['granularity'];
  placeholder: boolean;
}

export const toChartData = (inputData: LoadCurveSummaryEntry[]): ConsumptionData => {
  const data: ConsumptionData = {
    xAxisData: [],
    yAxisData: [],
  };

  inputData.forEach((item) => {
    data.xAxisData.push(
      format(parseISO(item.validFrom), 'yyyy-MM-dd HH:mm', {
        locale: de,
      }),
    );
    data.yAxisData.push(item.usageInKWh);
  });

  return data;
};

export const getColors = (utilityType: ConsumptionGraphConfigOptions['utilityType']) => {
  switch (utilityType) {
    case 'ELECTRICITY':
      return {
        line: 'rgb(0, 150, 137)',
        areaStop1: 'rgba(0, 150, 137, 0.35)',
        areaStop2: 'rgba(0, 150, 137, 0.03)',
      };
    case 'GAS':
      return {
        line: 'rgb(255, 105, 0)',
        areaStop1: 'rgba(255, 105, 0, 0.35)',
        areaStop2: 'rgba(255, 105, 0, 0.03)',
      };
  }
};
